import script from "./FenList.vue?vue&type=script&setup=true&lang=js"
export * from "./FenList.vue?vue&type=script&setup=true&lang=js"

import "./FenList.vue?vue&type=style&index=0&id=25a42900&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-25a42900"]])

export default __exports__